<template>
  <div class="dropdown ml-2">
    <a class="btn btn-outline-dark btn-sm" href="#" data-toggle="dropdown">
      <i class="fa fa-print"></i>  Print <i class="fa fa-caret-down"></i>
    </a>
    <div class="dropdown-menu" role="menu">
      <a class="dropdown-item" target="_blank" :href="url('/inbound-orders/'+order.id+'/receiving-slip')">
        <i class="fa fa-clipboard-list"></i>
        Receiving Slip
      </a>
      <a class="dropdown-item" target="_blank" :href="url('/inbound-orders/'+order.id+'/carton-labels')">
        <i class="fa fa-tags"></i>
        Labels
      </a>
      <a class="dropdown-item" target="_blank" :href="url('/inbound-orders/'+order.id+'/put-slip')">
        <i class="fa fa-people-carry"></i>
        Put Slip
      </a>
    </div>
  </div>
</template>

<script>
import printJS from 'print-js'
import api from '@/api.js'

export default {
  props: ['order'],

  methods: {
    url(doc) {
      return api.baseUrl + '/' + doc 
    },

    print(doc) {
      const url = api.baseUrl + '/' + doc 
      printJS({printable: url, type:'pdf', showModal:true, modalMessage: 'Building Document...' })
    }
  }
}
</script>